import {
  arrayRemove,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from 'firebase/firestore'
import { getDownloadURL, listAll, ref } from 'firebase/storage'

import { firestore, storage } from '../firebaseConfig'

export const getAList = async (listName: string) => {
  // TODO: replace with
  // const menu = await guardedCall(() => getDoc(doc(firestore, 'lists', listName)))
  try {
    const docRef = doc(firestore, 'lists', listName)

    const docSnapshot = await getDoc(docRef)

    if (docSnapshot.exists()) {
      const data = docSnapshot.data()
      return { data: data.items, error: null }
    }
  } catch (error) {
    return { data: null, error: error }
  }
}

interface ProfessorList {
  uid: string
  name?: string
}

export const updateAList = async (
  documentId: string,
  dataToChange: string | ProfessorList,
  type?: 'menu' | 'professors',
) => {
  const docRef = doc(firestore, 'lists', documentId)
  const docSnapshot = await getDoc(docRef)

  if (!docSnapshot.exists()) {
    await setDoc(docRef, { items: [dataToChange] })
    return
  }

  const currentItems = (docSnapshot.data()?.items ?? []) as (
    | string
    | ProfessorList
  )[]

  const isProfList = type === 'professors'
  const isProfessorPayload = typeof dataToChange !== 'string'

  // Pequeña protección por si alguien llama mal la función
  if (isProfList && !isProfessorPayload) {
    throw new Error('Se esperaba un ProfessorList para "professors"')
  }

  if (!isProfList && typeof dataToChange !== 'string') {
    throw new Error('Se esperaba un string para "menu"')
  }

  let exists = false
  let itemToRemove: string | ProfessorList | undefined

  if (isProfList) {
    const payload = dataToChange as ProfessorList
    itemToRemove = currentItems.find(
      (item): item is ProfessorList =>
        typeof item === 'object' && 'uid' in item && item.uid === payload.uid,
    )
    exists = Boolean(itemToRemove)
  } else {
    itemToRemove = currentItems.find(
      (item): item is string => item === dataToChange,
    )
    exists = Boolean(itemToRemove)
  }
  // TODO - AGREGAR CUANDO SE AGREGUE EL INPUT A InlineMenuProps
  //   else {
  //     const payload = dataToChange as string
  //     itemToRemove = currentItems.find(
  //       (item): item is string => typeof item === 'string' && item === payload,
  //     )
  //     exists = Boolean(itemToRemove)
  //   }

  // toggle: si existe lo sacamos, si no, lo agregamos
  await updateDoc(docRef, {
    items:
      exists && itemToRemove
        ? arrayRemove(itemToRemove)
        : arrayUnion(dataToChange),
  })
}

// NOT IN USE
export const getInvoiceList = async (uid: string) => {
  const nominasRef = ref(storage, `${uid}/nominas`)

  // Recorre las carpetas de años en "nominas"
  try {
    const yearFolders = await listAll(nominasRef)
    const newFilesByYear:
      | {
          year: number
          months: { month: string; url: string }[]
        }[]
      | null = []

    for (const yearFolder of yearFolders.prefixes) {
      const year = Number(yearFolder.name)
      const files = await listAll(yearFolder)

      const months = await Promise.all(
        files.items.map(async (file) => ({
          month: file.name,
          url: await getDownloadURL(file),
        })),
      )

      newFilesByYear.push({ year, months })
    }

    return newFilesByYear
  } catch (error) {
    console.error('Error al obtener los archivos:', error)
    return null
  }
}
